export function initOembedContainers() {
   onDomReady(() => {
      // Initialize all oembeds
      document.querySelectorAll('.oembedContainer').forEach(oembed => {
         const { width, height } = getComputedStyle(oembed);
         oembed.querySelectorAll(':scope > iframe').forEach(iframe => {
            iframe.setAttribute('width', width);
            iframe.setAttribute('height', height);
         });
      });
   });
}
